import React from "react";

const content = {
  zh: {
    header: {
      title: "欢迎来到 Henson Systems",
      subtitle: "团队核心成员现隶属于巴塞罗那计算机视觉中心与中关村壹号科技创新中心，持续站在全球人工智能发展的前沿。依托丰富的国际项目管理经验与科研产业融合能力，团队紧跟 AI 技术演进节奏，实时更新与迭代核心技术体系，确保解决方案始终保持先进性与落地性。",
    },
    items: [
      {
        icon: "/svg/auto-reply.svg",
        title: "24 小时客户联系",
        text: "用一个简洁现代的网站 + WhatsApp 接口，让客户随时联系你，24 小时持续获客转化",
      },
      {
        icon: "/svg/contact.svg",
        title: "AI 自动回复",
        text: "AI 自动回复客户消息，不错过任何咨询，让你的生意全天候在线成交",
      },
      {
        icon: "/svg/manage.svg",
        title: "智能体协助办公",
        text: "智能体协助日常办公，自动化处理任务，提升工作效率与质量",
      },
      {
        icon: "/svg/monitor.svg",
        title: "AI 业务监控",
        text: "AI在数据库层级监控业务和员工情况，实时预警风险，提升安全与运营效率",
      },
    ],
  },
  en: {
    header: {
      title: "Welcome to Henson Systems",
      subtitle: "Core team members are affiliated with the Computer Vision Center in Barcelona and Zhongguancun No. 1 Technology Innovation Center, continuously staying at the forefront of global AI development. Leveraging extensive international project management experience and the ability to integrate research with industry, the team keeps pace with AI technology evolution, continuously updating and iterating the core technology system to ensure solutions remain advanced and practical.",
    },
    items: [
      {
        icon: "/svg/contact.svg",
        title: "24/7 Customer Contact",
        text: "Use a concise modern website + WhatsApp interface to let customers reach you anytime, achieving 24/7 lead generation and conversion.",
      },
      {
        icon: "/svg/auto-reply.svg",
        title: "AI Auto-Reply",
        text: "AI automatically replies to customer messages, never missing any inquiry, keeping your business online and closing deals around the clock.",
      },
      {
        icon: "/svg/manage.svg",
        title: "AI Agent Office Assistant",
        text: "Agents assist daily office work, automate task handling, improve work efficiency and quality.",
      },
      {
        icon: "/svg/monitor.svg",
        title: "AI Business Monitoring",
        text: "AI monitors business and employee status at database level, real-time risk alerts, improving safety and operational efficiency.",
      },
    ],
  },
  es: {
    header: {
      title: "Bienvenido a Henson Systems",
      subtitle: "Los miembros principales del equipo están afiliados al Centro de Visión por Computadora de Barcelona y al Centro de Innovación Tecnológica Zhongguancun No. 1, manteniéndose continuamente a la vanguardia del desarrollo global de IA. Aprovechando la amplia experiencia en gestión de proyectos internacionales y la capacidad de integrar investigación con industria, el equipo sigue el ritmo de la evolución de la tecnología IA, actualizando e iterando continuamente el sistema tecnológico central para garantizar que las soluciones se mantengan avanzadas y prácticas.",
    },
    items: [
      {
        icon: "/svg/contact.svg",
        title: "Contacto 24/7",
        text: "Usa un sitio web conciso y moderno + interfaz de WhatsApp para permitir que los clientes te contacten en cualquier momento, logrando generación y conversión de leads 24/7.",
      },
      {
        icon: "/svg/auto-reply.svg",
        title: "Respuesta Automática IA",
        text: "La IA responde automáticamente a los mensajes de clientes, sin perder ninguna consulta, manteniendo tu negocio en línea y cerrando ventas las 24 horas.",
      },
      {
        icon: "/svg/manage.svg",
        title: "Asistente de Oficina con Agente IA",
        text: "Los agentes asisten el trabajo diario de oficina, automatizan el manejo de tareas, mejoran la eficiencia y calidad del trabajo.",
      },
      {
        icon: "/svg/monitor.svg",
        title: "Monitoreo de Negocio con IA",
        text: "La IA monitorea el estado del negocio y empleados a nivel de base de datos, alertas de riesgo en tiempo real, mejorando seguridad y eficiencia operativa.",
      },
    ],
  },
};

export default function CoreCapabilities({ lang }) {
  const t = content[lang];

  return (
    <section className="core-section">
      <div className="core-header">
        <h2 className="core-section-title">{t.header.title}</h2>
        <p className="core-section-subtitle">{t.header.subtitle}</p>
      </div>
      
      <div className="core-cards-container">
        {t.items.map((item, index) => (
          <div key={index} className="core-card">
            <img src={item.icon} alt={item.title} className="core-card-icon" />
            <h3 className="core-card-title">{item.title}</h3>
            <p className="core-card-text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
